// project imports
import mainPages from "./main-pages";

// types
import { NavItemType } from "types/menu";

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [mainPages],
};

export default menuItems;
